export var bids = [];
export var asks = [];
export var setBids = function setBids(bidsArg) {
  bids = bidsArg;
};
export var setAsks = function setAsks(asksArg) {
  asks = asksArg;
};